import type { App } from 'vue'

export const inifiteScroll = (app: App) => {
  app.directive('infinite-scroll', (el: HTMLElement, biding) => {
    el.addEventListener('scroll', () => {
      if (Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight) {
        biding.value()
      }
    })
  })
}
